import { Navigate, Route, Routes } from "react-router-dom";
import { TopBar } from "./components/TopBar";
import { ListPage } from "./pages/ListPage";
import { CreatePage } from "./pages/CreatePage";
import { DetailPage } from "./pages/DetailPage";

export default function App() {
  return (
    <div className="relative min-h-screen flex flex-col">
      <TopBar />
      <main className="flex-1 mx-auto max-w-7xl w-full px-6 py-10 relative z-10">
        <Routes>
          <Route path="/" element={<ListPage />} />
          <Route path="/new" element={<CreatePage />} />
          <Route path="/sandbox/:id" element={<DetailPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <footer className="mx-auto max-w-7xl w-full px-6 py-8 text-[10px] uppercase tracking-widest text-ink-600 flex items-center justify-between border-t border-ink-900">
        <span>
          simdb <span className="text-ink-700">//</span> ephemeral postgres
        </span>
        <span className="flex items-center gap-2">
          <span className="w-1 h-1 bg-phosphor-400" />
          destructible by design
        </span>
      </footer>
    </div>
  );
}
